module.exports = __webpack_public_path__ + "static/media/ribbonPrize.1ecc0443.svg";